import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CssVarsProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AuthProvider, useAuth } from './store/AuthContext';
import { AppLayout } from './components/AppLayout';
import { PrivateRoute } from './components/PrivateRoute';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Assessment } from './pages/Assessment';
import { DevDashboard } from './pages/DevDashboard';
import { ManagerDashboard } from './pages/ManagerDashboard';
import { ExecDashboard } from './pages/ExecDashboard';

function DashboardSwitch() {
  const { user } = useAuth();
  if (user?.role === 'manager') return <ManagerDashboard />;
  if (user?.role === 'exec') return <ExecDashboard />;
  return <DevDashboard />;
}

export default function App() {
  return (
    <CssVarsProvider theme={theme} defaultMode="system">
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Navigate to="/register/dev" replace />} />
              <Route path="/register/:roleHint" element={<Register />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardSwitch />
                  </PrivateRoute>
                }
              />
              <Route
                path="/assessment"
                element={
                  <PrivateRoute>
                    <Assessment />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </CssVarsProvider>
  );
}
